import type { ReactNode } from "react";

import { useTabSelection } from "../../hooks/useTabSelection";
import type { BaseTab, PageContentTabBase } from "../../types";

import TabsContent from "./TabsContent";

type Props<Tab> = {
    selectedTabId?: string | null;
    tabs: readonly Tab[];
    routeSync?: boolean;
    onTabClick?: (tabId: string) => void;
    onTabSelect?: (tabId: string) => void;
    /** Rendered full width between the tab bar and the tab panels. */
    belowTabsSlot?: ReactNode;
};

const TabbedPageContent = <Id extends string, Tab extends PageContentTabBase<BaseTab<Id>>>({
    tabs,
    selectedTabId,
    routeSync,
    onTabClick,
    onTabSelect,
    belowTabsSlot,
}: Props<Tab>) => {
    const [selectedTabIndex, setSelectedTabIndex] = useTabSelection<Id>({
        tabs,
        selectedTabId,
        routeSync,
        onTabSelect,
        onTabClick,
    });

    return (
        <TabsContent<Id, Tab>
            tabs={tabs}
            selectedTabId={selectedTabIndex}
            onTabSelect={setSelectedTabIndex}
            belowTabsSlot={belowTabsSlot}
        />
    );
};

export default TabbedPageContent;
